module.exports = __webpack_public_path__ + "img/CheckBox.28a8d36e.svg";